<template>
  <section class="k12-panel k12-panel-stretch">
    <div class="k12-panel-header">
      <div class="k12-panel-title">
        <span class="k12-icon"><i class="fas fa-sliders-h"></i></span>
        <span>{{ $t('preInvoiceV2.paymentInfo') }}</span>
      </div>
    </div>
    <div class="k12-panel-body ts-space-y-3">
      <div>
        <label class="required compact-label">{{ $t('preInvoiceV2.preInvoiceDate') }}</label>
        <a-date-picker
          v-model="model.pre_inv_date"
          class="ts-w-full"
          format="DD-MM-YYYY"
          valueFormat="DD-MM-YYYY"
          :allow-clear="false"
          @change="$emit('invoice-date-change')"
        />
      </div>
      <div>
        <label class="required compact-label">{{ $t('preInvoiceV2.exchangeRate') }}</label>
        <a-input-number v-model="model.exchange_rate" class="ts-w-full" :min="0" disabled />
      </div>
      <div class="total-card">
        <span>{{ $t('preInvoiceV2.totalAmount') }}</span>
        <strong>{{ formattedTotal }}</strong>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PaymentInfoSection',
  props: {
    model: { type: Object, required: true },
    formattedTotal: { type: String, required: true }
  }
}
</script>

<style scoped>
.compact-label {
  display: block;
  margin-bottom: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
}

.total-card {
  border: 1px solid #dbeafe;
  border-radius: 8px;
  background: #eff6ff;
  padding: 10px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #1e40af;
}

.total-card span {
  font-size: 12px;
  font-weight: 600;
}

.total-card strong {
  font-size: 18px;
  font-weight: 800;
}
</style>
